
import {
  computed, defineComponent, ref,
} from 'vue';
import BottomPopUpItem from '@/components/BottomPopUp/BottomPopUpItem.vue';
import AppBottomPopUp from '@/components/BottomPopUp/AppBottomPopUp.vue';
import { SHARE_SETTINGS } from '@/types/enums';
import { useMainStore } from '@/store/mainStore';

export default defineComponent({
  components: {
    BottomPopUpItem,
    AppBottomPopUp,
  },
  props: {
    shareSettings: { type: Array as () => SHARE_SETTINGS[] },
  },
  emits: ['close', 'update-settings'],
  setup(props, { emit }) {
    const mainStore = useMainStore();

    const sharingSettings = ref({
      allowedResharing: props.shareSettings?.includes(SHARE_SETTINGS.RESHARE_ALLOWED) || false,
      allowedSave: props.shareSettings?.includes(SHARE_SETTINGS.ALLOW_SAVE) || false,
      allowedDisplay: props.shareSettings?.includes(SHARE_SETTINGS.DISPLAY_ATTRIBUTION) || false,
    });

    const dummyResharing = computed(() => !sharingSettings.value.allowedResharing);

    function dummyResharingValueChange() {
      emit('update-settings', sharingSettings.value);
    }

    const dummySave = computed(() => sharingSettings.value.allowedSave);

    function dummySaveValueChange() {
      emit('update-settings', sharingSettings.value);
    }

    const showSettings = ref(false);

    function updateSettings() {
      emit('update-settings', sharingSettings.value);
    }

    function hidePopUp() {
      emit('close');
    }

    return {
      hidePopUp,
      dummyResharing,
      updateSettings,
      dummySave,
      showSettings,
      sharingSettings,
      dummySaveValueChange,
      dummyResharingValueChange,
    };
  },
});
